import React from 'react'
import Activities from '../components/Activities'

const Activity = () => {

  const pageName = "ACTIVITIES";

  return (
    <div>
      <Activities pageName={pageName}/>
    </div>
  )
}

export default Activity
